import Image_ from 'next/image';

const Image: any = Image_;

export default Image;
